const CancelRequest = {
  searchKey: "string",
  gdsRefrenceID: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
};

export default CancelRequest;
